<app-floorplan-product-menu
  [title]="tooltipTextPatientMonitors"
  [hasConfigurations]="patientMonitors.length > 0"
  [visible]="floorplan.floorplanState.patientMonitorsVisible"
  [locked]="floorplan.floorplanState.patientMonitorsLocked"
  [itemTextVisible]="floorplan.floorplanState.patientMonitorsItemTextVisible"
  (visibilityUpdate)="floorplan.floorplanState.patientMonitorsVisible = $event"
  (lockUpdate)="floorplan.floorplanState.patientMonitorsLocked = $event"
  (itemTextVisibilityUpdate)="updatePatientMonitorsItemTextVisibility($event)"
  (addPlaceholderToFloorplan)="addPlaceholder()"
  (dragPlaceholder)="dragPlaceholder()"
  configPath="patient-monitor"
>
  @for (patientMonitor of patientMonitors; track patientMonitor) {
    <div>
      <hr />
      <app-configured-product
        [productConfiguration]="patientMonitor"
        [imageUrl]="(getImageUrl$(patientMonitor) | async) || ''"
        [numberOfFloorplanItems]="floorplan.countPlacedPatientMonitors(patientMonitor)"
        [attachments]="[]"
        (add)="addPatientMonitor(patientMonitor)"
        (delete)="deletePatientMonitor(patientMonitor)"
        (dragStart)="drag(patientMonitor)"
        editPath="patient-monitor"
      >
      </app-configured-product>
    </div>
  }
</app-floorplan-product-menu>
